/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { YoutubeIntegrationListCuepointsQueryResponse, YoutubeIntegrationListCuepointsQueryParams, YoutubeIntegrationListCuepoints401, YoutubeIntegrationListCuepoints403 } from "../models/YoutubeIntegrationListCuepoints";

export function getYoutubeIntegrationListCuepointsUrl() {
  const res = { method: 'GET', url: `/youtube-integration/v1/cuepoints` as const }
  return res
}

/**
 * @summary Retrieve multiple CuepointEntities
 * {@link /youtube-integration/v1/cuepoints}
 */
export async function youtubeIntegrationListCuepoints(params?: YoutubeIntegrationListCuepointsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<YoutubeIntegrationListCuepointsQueryResponse, ResponseErrorConfig<YoutubeIntegrationListCuepoints401 | YoutubeIntegrationListCuepoints403>, unknown>({ method : "GET", url : getYoutubeIntegrationListCuepointsUrl().url.toString(), params, ... requestConfig })
  return res.data
}